import { DatePipe } from '@angular/common'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import * as moment from 'moment'
import { IndividualConfig, ToastrService } from 'ngx-toastr'

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(private router: Router, private toastr: ToastrService, private datePipe: DatePipe) {}

  createToasterConfig(): Partial<IndividualConfig> {
    return {
      enableHtml: true,
      progressBar: true,
      progressAnimation: 'decreasing',
      tapToDismiss: false,
      closeButton: true
    }
  }
  createShowMessage =
    (type: string) =>
    (msg: string, title: string = '', enableHtml: boolean = false) => {
      const toasterConfig = this.createToasterConfig()
      this.toastr[type](msg, title, toasterConfig)
      console.log(msg)
    }

  showSuccess = this.createShowMessage('success')

  showError = this.createShowMessage('error')

  showWarning = this.createShowMessage('warning')

  showInfo = this.createShowMessage('info')

  routeTo = (routingURL: string) => {
    this.router.navigateByUrl(routingURL)
  }

  navigateByCommands = (commands: any[]) => {
    this.router.navigate(commands)
  }

  formatDate = (format: string) => (date: string) => {
    const formattedDate = new Date(date)
    return this.datePipe.transform(formattedDate, format)
  }

  formatDateToDDMMYYHHMM = this.formatDate('dd:MM:yy HH:mm')

  toOrdinal(n: number) {
    const s = ['th', 'st', 'nd', 'rd'],
      v = n % 100
    return n + (s[(v - 20) % 10] || s[v] || s[0])
  }

  sortAndToOrdinal(days: number[]) {
    const copyDays = [...days]
    copyDays.sort((a, b) => a - b)
    return copyDays.map(this.toOrdinal)
  }

  convertTo24Hour(time12h: string) {
    const [time, period] = time12h.split(' ')
    const [hourStr, minuteStr] = time.split(':')
    const hour = parseInt(hourStr)
    const minute = parseInt(minuteStr)

    let hour24: number
    if (period === 'AM') {
      hour24 = hour === 12 ? 0 : hour
    } else {
      hour24 = hour === 12 ? 12 : hour + 12
    }

    const hour24Str = hour24.toString().padStart(2, '0')
    const minuteStrPadded = minute.toString().padStart(2, '0')
    return `${hour24Str}:${minuteStrPadded}`
  }

  convert24HourTo12Hour(time: string): string {
    const [hourStr, minuteStr, secondStr] = time.split(':')
    let hour = parseInt(hourStr, 10)
    const minute = parseInt(minuteStr, 10)

    const period = hour >= 12 ? 'PM' : 'AM'
    hour = hour % 12
    hour = hour ? hour : 12

    const formattedTime = `${hour}:${minute.toString().padStart(2, '0')} ${period}`
    return formattedTime
  }

  getDateFromDateTime(dateTimeString) {
    const date = moment(dateTimeString)
    return date.format('MM/DD/YYYY')
  }

  getTimeFromDateTime(dateTimeString) {
    const date = moment(dateTimeString)
    return date.format('h:mm A')
  }
}
